export enum FacetedSearch {
  NAME = 'faceted_search_slp_experiment',
  CONTROL_STANDARD_SEARCH = 'control',
  VARIANT_FACETED_SEARCH = 'variant',
}

export enum BrowseProvider {
  NAME = 'browse_provider',
  GOOGLE = 'google_retail',
  LOOP54 = 'loop54',
}
